import { useAppSelector } from 'hooks/reduxHooks'
import { OptimizelyClientSideExperiments, useOptimizelyExperiment } from 'lib/optimizely/optimizelyUtils'
import { useMemo } from 'react'

export default function useSearchSegments() {
  const geo = useAppSelector(state => state.geo)
  const canTrigger = geo.geoCountryCode === 'AU' && !!geo.geoStateName
  const auStateSegmentWeight = useOptimizelyExperiment(OptimizelyClientSideExperiments.searchAuStateSegmentRanking, canTrigger)
  const segments = useMemo(() => {
    return auStateSegmentWeight ? [`state:${geo.geoCountryCode}-${geo.geoStateName}:${auStateSegmentWeight}`] : []
  }, [auStateSegmentWeight, geo.geoCountryCode, geo.geoStateName])

  return segments
}
